<template>
    <div class="group-item-setting-view">
        <div v-if="addShow && value.length > 0" class="sub-header">
            <div class="front-block">
                <div class="handle"></div>
                <div class="title">項目名稱</div>
            </div>
            <template v-if="isShowAccno">
                <div class="front-block">
                    <div class="title">會計科目</div>
                </div>
                <div class="front-block">
                    <div class="title" style="width: 15px;"></div>
                </div>
            </template>
        </div>
        <div v-if="activeGroupSno && value.length <= 0">
            <div class="guide-msg-block center" style="margin-top: 50px">
                <div class="guide-msg-title">此群組尚未有子項目</div>
                <div class="guide-msg-description">有子項目的群組才會顯示於選單及分析中</div>
                <div class="guide-msg-actions">
                    <el-button v-if="addShow" type="primary" plain icon="el-icon-plus" @click="$emit('addClick')">新增子項目</el-button>
                </div>
            </div>
        </div>
        <DraggableWrapper
            :value="value"
            :onDragEnd="onDragEnd"
            :onAdd="onAdd"
            :onChange="onChange"
            :onEdit="onEdit"
            :addShow="addShow && value.length > 0"
            :activeSno="activeSno"
            :isShowAccno="isShowAccno"
            :isShowMem="true"
            @input="val => $emit('input', val)"
            @update="$emit('update')"
        >
        </DraggableWrapper>
    </div>
</template>

<script>
import DraggableWrapper from './DraggableWrapper.vue';

export default {
    props: {
        value: Array,

        onDragEnd: { type: Function, default: () => {} },
        onChange: { type: Function, default: () => {} },
        onEdit: { type: Function, default: () => {} },
        onAdd: { type: Function, default: () => {} },

        isShowAccno: Boolean,
        addShow: Boolean,
        activeSno: [Number, String],
        activeGroupSno: [Number, String],
    },
    components: { DraggableWrapper },
};
</script>

<style lang="scss">
.group-item-setting-view {
    .front-block {
        display: flex;
        align-items: center;

        .name {
            width: 230px;
            white-space: nowrap;
            overflow: hidden;

            .item-mem {
                color: #aaa;
                padding: 0 0 0 15px;
                font-size: 9pt;
            }
        }
    }

    &.group-setting-group-list {
        .front-block > .name {
            width: 230px;
        }
    }
    &.group-setting-item-list {
        .front-block > .name {
            width: 230px;
        }
    }

    .guide-msg-block {
        margin: 0 auto;
        color: #444;

        &.center {
            text-align: center;
        }

        .guide-msg-title {
            font-size: 12pt;
            font-weight: bold;
            margin: 0 0 10px 0;
        }

        .guide-msg-description {
            font-size: 10pt;
        }

        .guide-msg-actions {
            margin: 20px 0 0 0;
        }
    }
}
</style>
